module.exports = {
  "product.featured.partner.label": "PATROCINADO"
}
